import { proxy, useSnapshot } from 'valtio';
import type { ItemType } from 'antd/es/breadcrumb/Breadcrumb';

interface IBreadcrumbsStore {
  breadcrumbs: ItemType[];
  setBreadcrumbs: (items: ItemType[], padding?: boolean) => void;
}

const PRESET_LIST = [
  {
    title: '首页',
    href: '/home',
  },
];

const state = proxy<IBreadcrumbsStore>({
  breadcrumbs: [...PRESET_LIST],
  setBreadcrumbs(items = [], padding = true) {
    state.breadcrumbs = [...PRESET_LIST, ...items].slice(padding ? 0 : PRESET_LIST.length);
  },
});

export const breadcrumbsStore = state;

/** 面包屑状态快照 */
export const useSnapshotBreadcrumbs = () => useSnapshot(breadcrumbsStore) as IBreadcrumbsStore;
